/* eslint-disable camelcase */
/**
 * @author Fernando Ruano
 * @file index.js
 * @description Medical Parameter Services
 */

// Core
import endpoints from '@nephro/config/endpoints';
import { externalConnector } from '@nephro/core/connector';

// Endpoints
const { medicalParameter: medicalParameterEndpoints } = endpoints;

export class MedicalParameterService {
  constructor(http) {
    this.http = http;
  }

  /**
   * Get medical parameters list with pagination
   * @param { string } paged - Activate pagination.
   * @param { string } limit - Items per page.
   * @param { string } page - Current page.
   * @return { Object } - Get medical parameters list.
   */
  getMedicalParameters = async (paged, limit, page) => {
    const queryParam = `?limit=${limit}&page=${page}&paged=${paged}`;
    let url = medicalParameterEndpoints.base;
    if (paged) {
      url = `${url}${queryParam}`;
    }
    return this.http.get(url);
  };

  /**
   * Get medical parameter info by id
   * @param { string } id - MedicalParameter id.
   * @return { Object } - Get parameters list.
   */
  getMedicalParameterById = async (id) => {
    const url = `${medicalParameterEndpoints.base}/${id}`;
    return this.http.get(url);
  };

  /**
   * Delete medical parameter by id
   * @param { string } id - Medical parameter id.
   * @return { Object } - Get medical parameters list.
   */
  deleteMedicalParameterById = async (id) => {
    const url = `${medicalParameterEndpoints.base}/${id}`;
    return this.http.delete(url);
  };

  /**
   * Create medical parameter
   * @param { string } name - Medical parameter name.
   * @param { string } description - Medical parameter description.
   * @return { promise } - The medical parameter promise object.
   */
  createMedicalParameter = async (
    param_key,
    param_value,
    param_description
  ) => {
    const body = { param_key, param_value, param_description };
    const url = medicalParameterEndpoints.base;
    return this.http.post(url, body);
  };

  /**
   * Update medical parameter
   * @param { string } name - Medical parameter name.
   * @param { string } description - Medical parameter description.
   * @param { string } id - Medical parameter id.
   * @return { promise } - The medical parameter promise object.
   */
  updateMedicalParameter = async (
    param_key,
    param_value,
    param_description,
    id
  ) => {
    const body = { param_key, param_value, param_description };
    const url = `${medicalParameterEndpoints.base}/${id}`;
    return this.http.update(url, body, {}, 'put');
  };
}

export default new MedicalParameterService(externalConnector);
